import React from "react";
import "../css/Footer5.css";

const Footer5 = () => {
  return (
    <footer className="footer5">

      {/* TERRACED LAYERS */}
      <div className="f5-layer layer1"></div>
      <div className="f5-layer layer2"></div>
      <div className="f5-layer layer3"></div>

      {/* MAIN CONTENT */}
      <div className="f5-content">

        {/* LOGO + TAGLINE */}
        <div className="f5-brand">
          <h1>EARTHFIT</h1>
          <p>Move with purpose. Grow with nature.</p>
        </div>

        {/* LINKS GRID */}
        <div className="f5-grid">

          <div className="f5-col">
            <h3>Explore</h3>
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/workouts">Workouts</a>
            <a href="/services">Services</a>
          </div>

          <div className="f5-col">
            <h3>Programs</h3>
            <a href="/plans">Plans</a>
            <a href="/trainers">Trainers</a>
            <a href="/gallery">Gallery</a>
            <a href="/faqs">FAQs</a>
          </div>

          <div className="f5-col">
            <h3>Contact</h3>
            <p>+1 800 244 9023</p>
            <p>support@earthfit.com</p>
            <p>321 Greenway Rd, NY</p>

            <div className="f5-socials">
              <a href="#"><i className="ri-instagram-line"></i></a>
              <a href="#"><i className="ri-facebook-fill"></i></a>
              <a href="#"><i className="ri-youtube-fill"></i></a>
            </div>
          </div>

        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="f5-copy">
        © {new Date().getFullYear()} EARTHFIT — Rooted in Strength
      </div>

    </footer>
  );
};

export default Footer5;
